import naja from 'naja';

$(function () {
    isolateStoreGroupSortable();
});

naja.addEventListener('complete', () => {
    // Datagrid tree extension inserts children directly into the DOM, bypassing naja's
    // SnippetHandler. Naja 2.x uses direct binding (not event delegation), so expand
    // links on dynamically loaded children must be re-bound manually after each AJAX call.
    const tree = document.querySelector('[data-store-group-tree]');
    if (tree) {
        naja.uiHandler.bindUI(tree);
    }
    isolateStoreGroupSortable();
});

function isolateStoreGroupSortable() {
    $('[data-store-group-tree] .datagrid-tree-item-children').each(function () {
        const $el = $(this);
        if (!$el.hasClass('ui-sortable')) {
            return;
        }
        $el.sortable('option', 'connectWith', false);
        $el.sortable('option', 'containment', this);
    });
}
